import request from '@/utils/request';
import { BASE_API, BASE_WENJUAN, WENJUAN_URL } from '@/utils/consts'

//排班按月列表"
export function getMonthList(data) {
  return request(`${BASE_API}/clinic_scheduling/month/list`,{
    method:'POST',
    data
  });
}

// 添加快速排班
export function saveMonth(data) {
  return request(`${BASE_API}/clinic_scheduling/month/save`, {
    method: 'PUT',
    data
  })
}

// 获取快速排班
export function getMonth(data) {
  return request(`${BASE_API}/clinic_scheduling/month/get`, {
    method: 'POST',
    data
  })
}

// 清空快速排班
export function deleteMonth(data) {
  return request(`${BASE_API}/clinic_scheduling/delete/month/${data.clinic_id}/${data.schedule_date}`, {
    method: 'DELETE'
  });
}